<template>
  <div v-if="status" id="rose-chart">
    <div class="title" :style="{ color: '#FFFFFF' }">
      {{ title.title }}
    </div>
    <div class="content">
      <dv-charts :option="option" />
      <div class="detail">
        <span class="value">{{ value }}</span>
        <span class="unit">μg/m³</span>
      </div>
      <div class="describe" :style="{ color: status.color }">
        <span>{{ status.title_zh }}</span>
        <span>{{ status.title_en }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// 饼图对应颜色
export const STATUS_COLORS = {
  comfortable: "#32E85E",
  good: "#E6B900",
  mild: "#FF7900",
  moderate: "#FF222F",
  severe: "#BD31B0",
  serious: "#9841E1",
};

const AIR_QUALITY_STATUSES = [
  {
    quality: "0",
    title_zh: "舒适",
    title_en: "Comfortable",
    range: [0, 35],
    color: STATUS_COLORS.comfortable,
  },
  {
    quality: "1",
    title_zh: "良",
    title_en: "Good",
    range: [35, 75],
    color: STATUS_COLORS.good,
  },
  {
    quality: "2",
    title_zh: "轻度污染",
    title_en: "Mildly Polluted",
    range: [75, 115],
    color: STATUS_COLORS.mild,
  },
  {
    quality: "3",
    title_zh: "中度污染",
    title_en: "Moderately Polluted",
    range: [115, 150],
    color: STATUS_COLORS.moderate,
  },
  {
    quality: "4",
    title_zh: "重度污染",
    title_en: "Severely Polluted",
    range: [150, 250],
    color: STATUS_COLORS.severe,
  },
  {
    quality: "5",
    title_zh: "严重污染",
    title_en: "Seriously Polluted",
    range: [250, 500],
    color: STATUS_COLORS.serious,
  },
];

const TITLES = [
  {
    id: "pm25",
    title: "室内 INDOOR PM2.5",
    subTitle: "PM2.5",
  },
  {
    id: "outdoor_pm25",
    title: "室外 OUTDOOR PM2.5",
    subTitle: "PM2.5",
  },
];

export default {
  name: "AirQualityChart",
  props: {
    airQuality: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String, // pm25 or outdoor_pm25
      default: () => "",
    },
    value: {
      type: Number, // pm25 or outdoor_pm25
      default: () => "",
    }
  },
  data() {
    return {
      option: {},
      status: {}, // matched status
      title: {}, // title
    };
  },
  computed: {},
  mounted() {
    this.createData();
  },
  methods: {
    createData() {
      this.title = TITLES.find((x) => x.id == this.type);
      // this.value = parseFloat(this.airQuality[this.type]); // 获取读数
      this.status = AIR_QUALITY_STATUSES.find(
        (x) => x.range[0] < this.value && this.value <= x.range[1]
      );
      // console.log("*** status", this.status.color);
      this.option = {
        series: [
          {
            type: "gauge",
            grid: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
            radius: "80%",
            // center: ['50%','50%'],
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 10,
            min: 0,
            max: 500,
            backgroundArc: {
              show: false,
              style: {
                fill: "#0e0e1a",
              },
            },
            data: [
              {
                name: this.title,
                value: Math.max(0, 500 - this.value),
              },
            ],
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            dataItemStyle: {
              // lineCap: "round",
            },
            details: {
              show: false,
              offset: [0, 60],
              formatter: (dataItem) => {
                let arr = [`${dataItem.value}`];
                return arr.join("");
              },
              style: {
                fill: "#FFFFFF",
                fontSize: 35,
                fontWeight: "bold",
                textAlign: "center",
              },
            },
          },
        ],
        color: this.status ? [this.status.color] : [],
      };
    },
  },
};
</script>

<style lang="less">
#rose-chart {
  width: 100%;
  height: 100%;
  border-right: 1px solid #1d295d;
  /*border-top: 2px solid rgba(1, 153, 209, 0.5);*/
  /*box-sizing: border-box;*/
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  .rose-chart-title {
    /*height: 50px;*/
    /*font-weight: bold;*/
    /*text-indent: 20px;*/
    /*font-size: 20px;*/
    /*display: flex;*/
    /*align-items: center;*/
  }

  .dv-charts-container {
    width: 40%;
    height: 100%;
  }

  .title {
    width: 100%;
    font-size: 28px;

    font-weight: bold;
    line-height: 36px;
    text-align: center;
    margin-bottom: 20px;
  }
  .content {
    margin-left: 30px;
    display: flex;
    flex: 1;
    width: 100%;
    position: relative;
    .detail {
      width: 40%;
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .value {
        line-height: 20px;
        font-size: 20px;
        //font-family: DINPro-Bold, DINPro;
        font-weight: bold;
        color: #ffffff;
        line-height: 20px;
      }
      .unit {
        font-size: 14px;
        // font-family: DINPro-Medium, DINPro;
        font-weight: 500;
        color: #ffffff;
        line-height: 14px;
      }
    }
    .describe {
      display: flex;
      flex-direction: column;
      margin: auto 0;
      // justify-content: center;
      > span:nth-of-type(1) {
        height: 36px;
        font-size: 36px;

        font-weight: bold;
        line-height: 54px;
        margin-bottom: 9px;
      }
      > span:nth-of-type(2) {
        height: 18px;
        font-size: 18px;

        font-weight: bold;
        line-height: 27px;
      }
    }
  }
}
</style>
